import { makeUI } from '../data-driven';
import * as styled from './styled';

export const ui = cm => makeUI(styled)(cm);
